"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BANNER_CAROUSEL_BANNER = void 0;
const BANNER_CAROUSEL_BANNER = exports.BANNER_CAROUSEL_BANNER = 'banner-carousel-banner';
